"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Collapse = _interopRequireDefault(require("@components/Collapse"));

var _scss = require("@scss");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Accordion = /*#__PURE__*/(0, _react.forwardRef)(function Accordion(_ref, ref) {
  var className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$initialShow = _ref.initialShow,
      initialShow = _ref$initialShow === void 0 ? 0 : _ref$initialShow,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {
    wrapper: '',
    item: '',
    openItem: '',
    title: '',
    body: '',
    collapse: ''
  } : _ref$classes,
      _ref$allShown = _ref.allShown,
      allShown = _ref$allShown === void 0 ? false : _ref$allShown,
      _ref$lock = _ref.lock,
      lock = _ref$lock === void 0 ? false : _ref$lock,
      _ref$onOpenItemChange = _ref.onOpenItemChange,
      onOpenItemChange = _ref$onOpenItemChange === void 0 ? function () {} : _ref$onOpenItemChange,
      _ref$component = _ref.component,
      Tag = _ref$component === void 0 ? 'button' : _ref$component;

  var _useState = (0, _react.useState)(initialShow),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      currentIndex: show,
      openItem: function openItem(index) {
        if (index < items.length) {
          setShow(index);
          onOpenItemChange(index);
        }
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(classes['wrapper'], className),
    id: "accordion"
  }, items.map(function (item, i) {
    var _item$classes, _item$classes2;

    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: (0, _scss.cls)(classes['item'], i === show || allShown || item.show ? "".concat(classes['openItem'], " ").concat(_stylesModule["default"]['open']) : '', item === null || item === void 0 ? void 0 : (_item$classes = item.classes) === null || _item$classes === void 0 ? void 0 : _item$classes['element'])
    }, /*#__PURE__*/_react["default"].createElement(Tag, {
      className: (0, _scss.cls)('w-100', 'd-block', 'position-relative', _stylesModule["default"]['title'], classes['title'], item === null || item === void 0 ? void 0 : (_item$classes2 = item.classes) === null || _item$classes2 === void 0 ? void 0 : _item$classes2['title']),
      type: "button",
      "data-toggle": "collapse",
      "data-lock": allShown || lock || item.lock || item.show,
      "data-target": "#collapse".concat(i),
      "aria-expanded": i === show || allShown || item.show ? 'true' : 'false',
      "aria-controls": "#collapse".concat(i),
      id: "heading".concat(i),
      onClick: function onClick(e) {
        e.stopPropagation();

        if (allShown || lock || item.lock || item.show) {
          return;
        }

        setShow(show === i ? null : i);
        onOpenItemChange(show === i ? null : i);
      }
    }, item.title), /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
      isOpened: i === show || allShown || item.show,
      id: "collapse".concat(i),
      "aria-labelledby": "heading".concat(i),
      "data-parent": "#accordion",
      theme: {
        collapse: (0, _scss.cls)(classes['collapse'], _stylesModule["default"]['collapse']),
        content: classes['body']
      }
    }, typeof item.body === 'string' ? /*#__PURE__*/_react["default"].createElement("div", {
      dangerouslySetInnerHTML: {
        __html: item.body
      }
    }) : item.body));
  }));
});
var _default = Accordion;
exports["default"] = _default;